import { render, staticRenderFns } from "./dispatchConsoleSetUp.vue?vue&type=template&id=4351fa5d&scoped=true&"
import script from "./dispatchConsoleSetUp.vue?vue&type=script&lang=js&"
export * from "./dispatchConsoleSetUp.vue?vue&type=script&lang=js&"
import style0 from "./dispatchConsoleSetUp.vue?vue&type=style&index=0&id=4351fa5d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4351fa5d",
  null
  
)

export default component.exports